import { Col, Form, Upload } from 'antd'

import './styles.scss'
import { ImUpload } from 'react-icons/im'
import { TFieldProps } from '..'

export default function UploadMultipleDragFormField({
  fieldInfo,
  subsectionForm = false,
}: TFieldProps) {
  return (
    <Col xl={subsectionForm ? 24 : 8} md={subsectionForm ? 24 : 12} xs={24}>
      <Form.Item
        className={`upload-multiple-drag-field ${fieldInfo.className ?? ''}`}
        label={fieldInfo.label}
        name={fieldInfo.name}
        required={fieldInfo.required}
        tooltip={fieldInfo.description}
      >
        <Upload.Dragger multiple>
          <ImUpload className='upload-multiple-drag-icon' />

          <p className='ant-upload-text'>
            Haz click o suelta los archivos en esta área para adjuntar
          </p>
        </Upload.Dragger>
      </Form.Item>
    </Col>
  )
}
